import { registerLocaleData } from "@angular/common";
import moment from "moment";
export async function loadAngularLocaleDataAsync(locale) {
    // also load moment
    moment.locale(locale);
    switch (true) {
        case locale.startsWith("de_"):
            await import("@angular/common/locales/de").then((angularLocaleData) => {
                registerLocaleData(angularLocaleData.default);
            });
            break;
        case locale.startsWith("fr_"):
            await import("@angular/common/locales/fr").then((angularLocaleData) => {
                registerLocaleData(angularLocaleData.default);
            });
            break;
        case locale.startsWith("es_"):
            await import("@angular/common/locales/es").then((angularLocaleData) => {
                registerLocaleData(angularLocaleData.default);
            });
            break;
        case locale.startsWith("it_"):
            await import("@angular/common/locales/it").then((angularLocaleData) => {
                registerLocaleData(angularLocaleData.default);
            });
            break;
        case locale.startsWith("en_"):
        default:
            await import("@angular/common/locales/en").then((angularLocaleData) => {
                registerLocaleData(angularLocaleData.default);
            });
    }
}
